jQuery('.hoverall').on('mouseenter mouseleave', function (e) {
	jQuery(this).find('*').toggleClass('hover');
});
